/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Wallpaper = [
  ["path", { d: "M12 17v4" }],
  ["path", { d: "M8 21h8" }],
  ["path", { d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15" }],
  ["circle", { cx: "8", cy: "9", r: "2" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2" }]
];

export { Wallpaper as default };
//# sourceMappingURL=wallpaper.js.map
